export default "__VITE_ASSET__CkeoE10e__"